export type PlanKey = 'free' | 'standard' | 'premium';
export type BillingPeriod = 'monthly' | 'annual';

// One source of truth for listing pricing shown on the public site.
// Free = 3-month trial, then must upgrade.
// Standard & Premium are billed annually.
export const PUBLIC_PLANS = {
  free: {
    key: 'free' as const,
    name: 'Free',
    tier: 'basic' as const,
    monthlyPrice: 0,
    annualMonths: 0,
    trialDays: 0, // free forever, limited features
  },
  standard: {
    key: 'standard' as const,
    name: 'Standard',
    tier: 'featured' as const,
    monthlyPrice: 9,
    annualMonths: 12, // billed annually = $108/yr
  },
  premium: {
    key: 'premium' as const,
    name: 'Premium',
    tier: 'premium' as const,
    monthlyPrice: 19,
    annualMonths: 12, // billed annually = $228/yr
  },
} as const;

// Advertising plan (banner ads on MarineLink)
export const ADVERTISING_PLAN = {
  name: 'Advertising',
  monthlyPrice: 49,
  currency: 'nzd',
  description: 'Banner advertisement on MarineLink landing & category pages',
} as const;

// Renewal rates for listings that already have a paid/legacy tier.
export const RENEWAL_PRICES = {
  basic: { standard: 9, renewal: 9, name: 'Standard' },
  featured: { standard: 9, renewal: 9, name: 'Standard' },
  premium: { standard: 19, renewal: 19, name: 'Premium' },
} as const;

export function getPlanByKey(key: string) {
  return PUBLIC_PLANS[key as PlanKey] || null;
}

export function getPlanByTier(tier: string) {
  return Object.values(PUBLIC_PLANS).find((plan) => plan.tier === tier) || null;
}

export function annualTotal(monthlyPrice: number, annualMonths = 12) {
  return monthlyPrice * annualMonths;
}

export function annualMonthlyEquivalent(monthlyPrice: number, annualMonths = 12) {
  return annualTotal(monthlyPrice, annualMonths) / 12;
}
